export type CommunicationListenOptions = {
	once?: boolean; // If true, the listener will be removed after the first invocation
};

const defaultListenOptions: CommunicationListenOptions = {
	once: false,
};

const createCommunication = <DataType>(eventType: string) => ({
	listen: (
		callback: (data: DataType) => void,
		options = defaultListenOptions
	) => {
		const listener = (event: Event) => {
			if (event instanceof CustomEvent) {
				callback(event.detail);

				if (options?.once) {
					window.removeEventListener(eventType, listener);
				}
			}
		};

		window.addEventListener(eventType, listener);

		return () => window.removeEventListener(eventType, listener);
	},
	dispatch: (data: DataType) =>
		window.dispatchEvent(new CustomEvent(eventType, { detail: data })),
});

class InterComponentCommunications {
	static advisorCenter = {
		chatBlkConfigLocalStorageSet: createCommunication<string>(
			'chatblk-config-local-storage-set'
		),
	};
}

export default InterComponentCommunications;
